<template>
  <v-app>
    <v-main>
      <component :is="layout" />
    </v-main>
    <v-footer app class="caption font-weight-regular grey--text">
      Dark Wolf Solutions, LLC
    </v-footer>
  </v-app>
</template>

<script>
import defaultLayout from '@/components/appLayout/defaultLayout.vue';
import loginForm from '@/components/appLayout/loginForm.vue';
import pageNotFound from '@/components/appLayout/pageNotFound.vue';
import pageNotAllowed from '@/components/appLayout/pageNotAllowed.vue';
import pageLoading from '@/components/appLayout/pageLoading.vue';
import termsOfUse from '@/components/appLayout/termsOfUse.vue';

export default {
  name: 'App',
  components: {
    'default-layout': defaultLayout,
    'terms-of-use-layout': termsOfUse,
    'login-layout': loginForm,
    'err-layout': pageNotFound,
    'auth-layout': pageNotAllowed,
    'loading-layout': pageLoading
  },
  computed: {
    layout() {
      return this.$store.getters.layout;
    }
  }
};
</script>

<style>
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background-color: #6b6b6b;
}
::-webkit-scrollbar-thumb {
  background-color: #949494;
}
</style>
